"use client";
import React from "react";
import { Modal } from "antd";
import AppQRCode from "components/common/AppQRCode";
import AppStoreButtons from "components/common/AppStoreButtons";
import { useT } from "providers/I18nProvider";
import useStoreUrl from "hooks/useStoreUrl";

interface BookingQRModalProps {
  open: boolean;
  onClose: () => void;
  /** "booking" (mặc định) = đặt lịch; "package" = mua gói tiết kiệm */
  variant?: "booking" | "package";
}

const BookingQRModal: React.FC<BookingQRModalProps> = ({
  open,
  onClose,
  variant = "booking",
}) => {
  const t = useT();
  const storeUrl = useStoreUrl();
  const isPackage = variant === "package";

  return (
    <Modal
      rootClassName="lm-sheet"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
      title={null}
    >
      <div className="flex flex-col items-center text-center py-2">
        {/* Thông báo chính: đặt lịch chỉ có trên app */}
        <div className="w-full rounded-xl bg-primary/10 px-4 py-3 mb-3 mt-4">
          <p className="!mb-0 text-[15px] font-semibold text-primary">
            {t(isPackage ? "bookingModal.packageNotice" : "bookingModal.notice")}
          </p>
        </div>
        <p className="text-gray-600 text-sm mb-4">{t(isPackage ? "bookingModal.packageDescription" : "bookingModal.description")}</p>

        {/* Mobile: đang cầm điện thoại → 1 nút mở thẳng App Store / Google Play
            (chốt với chị Naomi 05/10: luôn báo "tính năng trên app" trước khi chuyển) */}
        <a
          href={storeUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
          className="md:hidden flex h-12 w-full items-center justify-center rounded-full text-[16px] font-semibold"
          style={{ backgroundColor: "var(--primary)", color: "#fff" }}
        >
          {t("bookingModal.openStore")}
        </a>

        <div className="hidden md:flex flex-col items-center">
          <AppQRCode sizeClassName="w-40 h-40" />
          <p className="text-sm text-gray-500 mt-3 !mb-1">
            {t("bookingModal.scanQR")}
          </p>
          <p className="text-xs text-gray-400 mb-3">{t("bookingModal.orDownload")}</p>
          <AppStoreButtons size="md" />
        </div>
      </div>
    </Modal>
  );
};

export default BookingQRModal;
